/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_REALM_SETTINGS_START, GET_REALM_SETTINGS_SUCCESS, GET_REALM_SETTINGS_FAILURE } from "./types";

export const getRealmSettingsStart = () => {
  return {
    type: GET_REALM_SETTINGS_START
  };
};

export const getRealmSettingsSuccess = (realmSettings: any) => {
  return {
    type: GET_REALM_SETTINGS_SUCCESS,
    realmSettings,
  };
};

export const getRealmSettingsFailure = (error: any) => {
  return {
    type: GET_REALM_SETTINGS_FAILURE,
    error,
  };
};
